export default __webpack_public_path__ + "static/media/aide_aux_entreprises.1effd0f6.webp";